import { DateTime } from 'luxon';

import { USER_LOCALE } from '../constants';

export const formatDate = (date: Date) => {
  const year = date.getFullYear();
  const month = String(date.getMonth() + 1).padStart(2, '0');
  const day = String(date.getDate()).padStart(2, '0');
  const hours = String(date.getHours()).padStart(2, '0');
  const minutes = String(date.getMinutes()).padStart(2, '0');
  const seconds = String(date.getSeconds()).padStart(2, '0');

  return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;
};

export const formatDateTime = (d: string) => {
  const date = DateTime.fromISO(d).setLocale(USER_LOCALE);

  return date.toFormat('dd MMMM HH:mm:ss yyyy');
};

export const roundToTenth = (num: number, decimals = 1): number => {
  return Math.round(num * 10 ** decimals) / 10 ** decimals;
};

export function calculateDays(startDate: string, endDate: string): number {
  const startDatetime = new Date(startDate);
  const endDatetime = new Date(endDate);

  const timeDifference = endDatetime.getTime() - startDatetime.getTime();
  const days = Math.ceil(timeDifference / (1000 * 3600 * 24));

  return days;
}

export function roundToNearestAfterDecimal(num: number, precision = 1): number {
  if (Number.isInteger(num)) {
    return num;
  }

  const numStr = num.toString();
  let firstNonZeroIndex = numStr.indexOf('.') + 1;

  // Находим первую ненулевую цифру после запятой
  while (numStr[firstNonZeroIndex] === '0') {
    firstNonZeroIndex++;
  }

  if (firstNonZeroIndex >= numStr.length) {
    return 0;
  }

  // Определяем разрядность для округления
  const factor = Math.pow(10, firstNonZeroIndex - numStr.indexOf('.') + precision - 1);

  return Math.round(num * factor) / factor;
}
